import { isValid, format } from 'date-fns';
import { timing } from 'constants/ui.constants';
import _ from 'lodash';
import type { ReportKey } from 'state/reducers/reports.reducers';

export enum ReportInputFields {
	REPORT_TYPE = 'ReportType',
	DATE_RANGE = 'DateRange',
	BENEFICIARY_ID = 'BeneficiaryId',
}

/** Generic warning/alert art for ImagePopup (orange exclamation) */
export const WARNING_EXCLAMATION_ICON = '/icons/warning-exclamation.png';

export const reportsCatalogTranslationKeys: Partial<Record<ReportKey, string>> = {
	beneficiaries_report: 'page.reports.report_type.beneficiaries_report.text',
	balances_report: 'page.reports.report_type.balances_report.text',
	activities_report: 'page.reports.report_type.activities_report.text',
	account_management_report: 'page.reports.report_type.account_management_report.text',
	accounting_final_report: 'page.reports.report_type.accounting_final_report.text',
	payment_status_report: 'page.reports.report_type.payment_status_report.text',
	fx_conversions_report: 'page.reports.report_type.fx_conversions_report.text',
	beneficiary_payments_report: 'page.reports.report_type.beneficiary_payments_report.text',
	payment_fees_report: 'page.reports.report_type.payment_fees_report.text',
};

export const formatDate = (value: any) => {
	return !_.isNil(value) && isValid(new Date(value)) ? format(new Date(value), timing.DATE) : value;
};
